<ion-header>
  <ion-toolbar>
    <ion-title>Validation par responsable</ion-title>
    <ion-button (click)="dismissModal()" slot="end" fill="clear">
      <ion-icon slot="icon-only" name="close"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-row class="ion-justify-content-center ion-margin-vertical" [formGroup]="form">
  <ion-col size="9" class="ion-no-padding">
    <ion-item class="ion-margin-vertical c-item-input" lines="none">
      <ion-input placeholder="Matricule" formControlName="matricule"></ion-input>
    </ion-item>
    <ion-item class="ion-margin-vertical c-item-input" lines="none">
      <ion-input placeholder="Mot de passe" type="password" formControlName="password"></ion-input>
    </ion-item>
    <ion-row class="ion-justify-content-center ion-margin-vertical">
      <ion-col size="12">
        <ion-button color="light" (click)="onCheckButtonClick()" expand="block">
          Se connecter
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>